import React from "react";

export interface TranslateIconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Universal circular translation icon (文A) matching the platform UI design.
 */
export const TranslateIcon: React.FC<TranslateIconProps> = ({
  size = 28,
  className = "",
  style = {},
}) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={className}
      style={{ display: "block", flexShrink: 0, ...style }}
      aria-hidden="true"
    >
      {/* Outer circular badge */}
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeOpacity="0.75"
        strokeWidth="1.4"
      />
      {/* Glyphs: 文 (top-left) and A (bottom-right) */}
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Top dot of 文 */}
        <line x1="10.6" y1="6.7" x2="10.6" y2="8.3" />
        {/* Horizontal bar of 文 */}
        <line x1="6.4" y1="8.7" x2="14.4" y2="8.7" />
        {/* Left curved sweep of 文 */}
        <path d="M 10.4 9.4 C 10.0 11.7 8.7 13.9 6.7 15.4" />
        {/* Right diagonal slash of 文 */}
        <line x1="9.1" y1="10.7" x2="12.8" y2="15.2" />
        {/* Capital Letter A */}
        <path d="M 12.5 17.3 L 15.1 11.0 L 17.7 17.3" />
        {/* Crossbar of A */}
        <line x1="13.4" y1="15.0" x2="16.8" y2="15.0" />
      </g>
    </svg>
  );
};

export default TranslateIcon;
